import { getEffectiveHouseId } from '@/utils/getEffectiveHouseId';
import { houseOverrideAtom } from '@/atoms/houseOverride/houseOverrideAtom';
import { useAppContext } from '@/providers/AppContextProvider/AppContextProvider';
import { useAtomValue } from 'jotai';

/**
 * Returns the effective house ID for the current session.
 *
 * For ATG admins: returns the active house override from the Jotai atom (seeded
 * from the houseOverride cookie on load via HouseOverrideInitializer) when set,
 * otherwise falls back to the JWT houseId.
 * For all other roles: always returns the JWT houseId.
 *
 * Do not read the houseOverride cookie here — js-cookie is client-only and
 * diverges from SSR, which hydrates NavIdentity with a different house id.
 *
 * Use this in every data/use* hook instead of reading userDecoded.houseId directly.
 */
export const useEffectiveHouseId = (): string => {
    const { userDecoded } = useAppContext();
    const houseOverride = useAtomValue(houseOverrideAtom);

    return getEffectiveHouseId(userDecoded, houseOverride ?? undefined);
};
